import { Card } from "@/components/ui/card";
import { SUGGESTED_QUESTIONS, RECENT_TOPICS, QUICK_CONTEXT } from "./advisorModel";

const Panel = ({ title, children }) => (
  <Card className="bg-[#0f1419] border-gray-800/50 p-6">
    <h3 className="text-lg font-semibold text-white mb-4">{title}</h3>
    {children}
  </Card>
);

export const AdvisorSidebar = ({ onPick }) => (
  <div className="space-y-6">
    <Panel title="Suggested Questions">
      <div className="space-y-2">
        {SUGGESTED_QUESTIONS.map((q, idx) => (
          <button key={q} onClick={() => onPick(q)} data-testid={`suggested-q-${idx}`}
            className="w-full text-left p-3 bg-white/5 hover:bg-white/10 border border-gray-700/50 hover:border-[#3dd9c5]/50 rounded-lg text-sm text-gray-300 transition-all">
            {q}
          </button>
        ))}
      </div>
    </Panel>
    <Panel title="Quick Context">
      <div className="space-y-3 text-sm">
        {QUICK_CONTEXT.map((c) => (
          <div key={c.label}>
            <p className="text-gray-500 mb-1">{c.label}</p>
            <p className={`${c.accent ? "text-[#3dd9c5]" : "text-white"} font-semibold`}>{c.value}</p>
          </div>
        ))}
      </div>
    </Panel>
    <Panel title="Recent Topics">
      <div className="space-y-2">
        {RECENT_TOPICS.map((topic) => (
          <div key={topic} className="p-2 bg-[#3dd9c5]/10 border border-[#3dd9c5]/30 rounded text-xs text-[#3dd9c5]">{topic}</div>
        ))}
      </div>
    </Panel>
  </div>
);
